import React from 'react';
import BEButton from '@molecules/Button/Button';

import { Flex, Spacer, Box, Divider } from '@chakra-ui/react';

const DemoButton = () => {
  function onClickButton(e: React.MouseEvent<HTMLButtonElement>) {
    console.log('onClickButton', e);
  }

  return (
    <Box>
      <h2>Buttons</h2>
      <Divider m={2} />
      <Flex align={'center'}>
        <p>Default Button</p>
        <Spacer />
        <BEButton onClick={(e) => onClickButton(e)}>Click me please</BEButton>
      </Flex>
      <Divider m={2} />
      <Flex align={'center'} gap={2}>
        <p>Colors</p>
        <Spacer />
        <BEButton color="primary" onClick={(e) => onClickButton(e)}>
          Primary
        </BEButton>
        <BEButton color="neutral" onClick={(e) => onClickButton(e)}>
          Neutral
        </BEButton>
        <BEButton color="warning" onClick={(e) => onClickButton(e)}>
          Warning
        </BEButton>
        <BEButton color="error" onClick={(e) => onClickButton(e)}>
          Error
        </BEButton>
      </Flex>
      <Divider m={2} />
      <Flex align={'center'}>
        <p>Loading</p>
        <Spacer />
        <BEButton isLoading={true} onClick={(e) => onClickButton(e)}>
          Click me please
        </BEButton>
      </Flex>
      <Divider m={2} />
      <Flex align={'center'}>
        <p>Outline</p>
        <Spacer />
        <BEButton variant="outline" onClick={(e) => onClickButton(e)}>
          Click me please
        </BEButton>
      </Flex>
      <Divider m={2} />
      <Flex align={'center'} gap={2}>
        <p>Sizes</p>
        <Spacer />
        <BEButton size="lg" onClick={(e) => onClickButton(e)}>
          Large
        </BEButton>
        <BEButton size="md" onClick={(e) => onClickButton(e)}>
          Medium
        </BEButton>
        <BEButton size="sm" onClick={(e) => onClickButton(e)}>
          Small
        </BEButton>
        <BEButton size="xs" onClick={(e) => onClickButton(e)}>
          extra small
        </BEButton>
      </Flex>
      <Divider m={2} />
      <Flex align={'center'} gap={2}>
        <p>Black</p>
        <Spacer />
        <BEButton color="black" onClick={(e) => onClickButton(e)}>
          Click me please
        </BEButton>
      </Flex>
      <Divider m={2} />
      <Flex align={'center'} gap={2}>
        <p>Ghost</p>
        <Spacer />
        <BEButton variant="ghost" onClick={(e) => onClickButton(e)}>
          Click me please
        </BEButton>
      </Flex>
    </Box>
  );
};

export default DemoButton;
